export default "__VITE_ASSET__PJDFhFdlzz6i7QMvLW3v2g__"